import amplitude from 'amplitude-js';
import axios from 'src/adapters/axios';
import { AMPLITUDE_KEY, IS_INTERNAL_ORIGIN, IS_PROD, uri } from 'src/config';
import { EVENT_TYPE } from 'src/function-utils/telemetry';
import debounce from './debounce';
amplitude.getInstance().init(AMPLITUDE_KEY, null, {
    apiEndpoint: uri.telemetry,
    disableCookies: true,
    forceHttps: IS_PROD,
    optOut: !IS_PROD,
});
const DEBOUNCE_TIMEOUT = 2000;
let payloadQueue = [];
let tempStopTracking = false;
const tempStopTrackingExemption = [EVENT_TYPE.load_widget];
const dispatchSend = debounce(_dispatchSend, DEBOUNCE_TIMEOUT);
/**
 * Temporarily stops tracking.
 */
export function setTempStopTracking(value) {
    tempStopTracking = value;
}
/**
 * Batches up events to be sent and schedules them to be dispatched.
 */
function sendTelemetryEvent(payload) {
    if (IS_INTERNAL_ORIGIN ||
        (tempStopTracking && !tempStopTrackingExemption.includes(payload.eventType))) {
        return;
    }
    // Disabled for now since it's consuming too many function calls
    // payloadQueue.push(payload);
    // dispatchSend();
    amplitude.getInstance().logEvent(payload.eventType, Object.assign({ business_key: payload.businessKey }, payload.eventProperties));
    return true;
}
/**
 * Dispatches queued events and flushes the queue.
 */
function _dispatchSend() {
    const encodedData = btoa(JSON.stringify(payloadQueue));
    const res = axios.post(uri.telemetryPost, null, {
        params: {
            data: encodedData,
        },
        headers: {
            'Content-Type': 'text/plain; charset=utf-8',
        },
    });
    payloadQueue = [];
    return res;
}
/**
 * Tracks widget load event.
 */
export function trackWidgetLoad(userId, businessKey) {
    sendTelemetryEvent({
        eventType: EVENT_TYPE.load_widget,
        userId,
        businessKey,
    });
}
let openedSmallCard = false;
/**
 * Tracks open small card event.
 */
export function trackOpenSmallCard(userId, businessKey) {
    if (openedSmallCard) {
        return;
    }
    sendTelemetryEvent({
        eventType: EVENT_TYPE.open_small_card,
        userId,
        businessKey,
    }) && (openedSmallCard = true);
}
let seenSmallCardPageMap = [];
/**
 * Tracks see small card page event.
 */
export function trackSeeSmallCardPage(userId, businessKey, page) {
    if (seenSmallCardPageMap[page]) {
        return;
    }
    sendTelemetryEvent({
        eventType: EVENT_TYPE.see_small_card_page,
        userId,
        businessKey,
        eventProperties: {
            page,
        },
    }) && (seenSmallCardPageMap[page] = true);
}
/**
 * Tracks wall of love load event.
 */
export function trackWallOfLoveLoad(userId, businessKey) {
    sendTelemetryEvent({
        eventType: EVENT_TYPE.load_wall_of_love,
        userId,
        businessKey,
    });
}
/**
 * Tracks marquee load event.
 */
export function trackMarquee(userId, businessKey) {
    sendTelemetryEvent({
        eventType: EVENT_TYPE.load_marquee,
        userId,
        businessKey,
    });
}
export { EVENT_TYPE };
